/* global CONFIG */
import services from '../services'

export default {
  getDriverList (VueApp, onDuty, isStaging, callback) {
    let self = this
    let token = VueApp.$store.state.session.sessionToken
    let request = {
      token: token,
      duty: onDuty ? 1 : 0
    }

    // Page number and size
    let pageNumber = VueApp.$store.state.dispatch.onDuty.pageNum
    let pageSize = VueApp.$store.state.dispatch.onDuty.pageSize
    if (!onDuty) {
      pageNumber = VueApp.$store.state.dispatch.offDuty.pageNum
      pageSize = VueApp.$store.state.dispatch.offDuty.pageSize
    }
    if (isStaging) {
      pageNumber = VueApp.$store.state.dispatch.staging.pageNum
      pageSize = VueApp.$store.state.dispatch.staging.pageSize
    }
    request.pageNum = pageNumber
    request.pageSize = pageSize

    // Sorting
    let order = VueApp.$store.state.dispatch.onDuty.order
    let asc = VueApp.$store.state.dispatch.onDuty.asc
    if (!onDuty) {
      order = VueApp.$store.state.dispatch.offDuty.order
      asc = VueApp.$store.state.dispatch.offDuty.asc
    }
    if (isStaging) {
      order = VueApp.$store.state.dispatch.staging.order
      asc = VueApp.$store.state.dispatch.staging.asc
    }
    request.order = order
    request.orderAsc = asc ? 1 : 0

    // Search field
    if (VueApp.$store.state.dispatch.driverListFilters.search !== '') {
      request.search = VueApp.$store.state.dispatch.driverListFilters.search
    }

    // Service Type filter
    if (VueApp.$store.state.dispatch.driverListFilters.serviceTypes.length > 0 &&
        VueApp.$store.state.dispatch.driverListFilters.serviceTypes.length < 5) {
      request.serviceType = VueApp.$store.state.dispatch.driverListFilters.serviceTypes
    }

    VueApp.$sdk.get('/provider', request, r => {
      if (r.error) {
        console.log(r)
        callback(r)
        return
      }

      let result = []
      for (let i = 0; i < r.list.length; i++) {
        result.push(self.formatData(r.list[i], false, VueApp))
      }

      let listMutation = 'dispatch/setOnDutyDrivers'
      let pageNumMutation = 'dispatch/setOnDutyPageNumber'
      let totalPageMutation = 'dispatch/setOnDutyTotalPages'
      if (!onDuty) {
        listMutation = 'dispatch/setOffDutyDrivers'
        pageNumMutation = 'dispatch/setOffDutyPageNumber'
        totalPageMutation = 'dispatch/setOffDutyTotalPages'
      }
      if (isStaging) {
        listMutation = 'dispatch/setStagingDrivers'
        pageNumMutation = 'dispatch/setStagingPageNumber'
        totalPageMutation = 'dispatch/setStagingTotalPages'
      }
      VueApp.$store.commit(listMutation, result)
      VueApp.$store.commit(pageNumMutation, parseInt(r.paging.pageNum))
      VueApp.$store.commit(totalPageMutation, r.paging.totalItems)
      callback(r)
    })
  },

  getDriverListV2 (VueApp, data, callback) {
    let self = this
    let token = VueApp.$store.state.session.sessionToken
    let request = {
      token: token,
      duty: data.onDuty ? 1 : 0
    }

    // Page number and size
    let pageNumber = VueApp.$store.state.dispatch.onDuty.pageNum
    let pageSize = VueApp.$store.state.dispatch.onDuty.pageSize
    if (!data.onDuty) {
      pageNumber = VueApp.$store.state.dispatch.offDuty.pageNum
      pageSize = VueApp.$store.state.dispatch.offDuty.pageSize
    }
    if (data.isStaging) {
      pageNumber = VueApp.$store.state.dispatch.staging.pageNum
      pageSize = VueApp.$store.state.dispatch.staging.pageSize
    }
    request.pageNum = pageNumber
    request.pageSize = pageSize

    // Sorting
    let order = VueApp.$store.state.dispatch.onDuty.order
    let asc = VueApp.$store.state.dispatch.onDuty.asc
    if (!data.onDuty) {
      order = VueApp.$store.state.dispatch.offDuty.order
      asc = VueApp.$store.state.dispatch.offDuty.asc
    }
    if (data.isStaging) {
      order = VueApp.$store.state.dispatch.staging.order
      asc = VueApp.$store.state.dispatch.staging.asc
    }
    request.order = order
    request.orderAsc = asc ? 1 : 0

    // Search field
    if (VueApp.$store.state.dispatch.driverListFilters.search !== '') {
      request.search = VueApp.$store.state.dispatch.driverListFilters.search
    }

    // Service Type filter
    request.serviceTypeId = VueApp.$store.state.dispatch.serviceFilter.list
    // if (VueApp.$store.state.dispatch.serviceFilter.list.length) {
    // if (data.services.length) {
    // }

    VueApp.$sdk.post('/provider', request, r => {
      VueApp.$store.commit('dispatch/setDriversTotal', {
        field: data.onDuty ? 'onDuty' : 'offDuty',
        value: 0
      })
      if (r.error) {
        console.log(r)
        callback(r)
        return
      }

      let result = []
      for (let i = 0; i < r.list.length; i++) {
        result.push(self.formatData(r.list[i], false, VueApp))
      }

      let listMutation = 'dispatch/setOnDutyDrivers'
      let pageNumMutation = 'dispatch/setOnDutyPageNumber'
      let totalPageMutation = 'dispatch/setOnDutyTotalPages'
      if (!data.onDuty) {
        listMutation = 'dispatch/setOffDutyDrivers'
        pageNumMutation = 'dispatch/setOffDutyPageNumber'
        totalPageMutation = 'dispatch/setOffDutyTotalPages'
      }
      if (data.isStaging) {
        listMutation = 'dispatch/setStagingDrivers'
        pageNumMutation = 'dispatch/setStagingPageNumber'
        totalPageMutation = 'dispatch/setStagingTotalPages'
      }
      VueApp.$store.commit(listMutation, result)
      VueApp.$store.commit(pageNumMutation, parseInt(r.paging.pageNum))
      VueApp.$store.commit(totalPageMutation, r.paging.totalItems)
      VueApp.$store.commit('dispatch/setDriversTotal', {
        field: data.onDuty ? 'onDuty' : 'offDuty',
        value: r.paging.totalItems
      })
      callback(r)
    })
  },

  getOnDutyDrivers (VueApp) {
    let self = this
    let token = VueApp.$store.state.session.sessionToken
    let request = {
      token: token,
      duty: 1,
      pageNum: VueApp.$store.state.dispatch.onDuty.pageNum,
      pageSize: VueApp.$store.state.dispatch.onDuty.pageSize,
      order: VueApp.$store.state.dispatch.onDuty.order,
      orderAsc: VueApp.$store.state.dispatch.onDuty.asc ? 1 : 0
    }
    VueApp.$store.commit('dispatch/setOnDutyLoading', true)
    VueApp.$store.commit('dispatch/setDriversTotal', {
      field: 'onDuty',
      value: 0
    })
    VueApp.$sdk.get('/provider', request, r => {
      VueApp.$store.commit('dispatch/setOnDutyLoading', false)
      if (r.error) {
        VueApp.$store.commit('dispatch/setServiceCount', {
          shared: 0,
          opoli: 0,
          black: 0,
          suv: 0,
          shuttle: 0
        })
        console.log(r)
        return
      }

      let result = []
      for (let i = 0; i < r.list.length; i++) {
        result.push(self.formatData(r.list[i], false, VueApp))
      }

      VueApp.$store.commit('dispatch/setServiceCount', r.services)
      VueApp.$store.commit('dispatch/setOnDutyDrivers', result)
      VueApp.$store.commit('dispatch/setDriversTotal', {
        field: 'onDuty',
        value: r.paging.totalItems
      })
      if (r.paging) {
        VueApp.$store.commit('dispatch/setOnDutyTotalPages', r.paging.totalItems)
      }
    })
  },

  getOffDutyDrivers (VueApp) {
    let self = this
    let token = VueApp.$store.state.session.sessionToken
    let request = {
      token: token,
      duty: 0,
      pageNum: VueApp.$store.state.dispatch.offDuty.pageNum,
      pageSize: VueApp.$store.state.dispatch.offDuty.pageSize,
      order: VueApp.$store.state.dispatch.offDuty.order,
      orderAsc: VueApp.$store.state.dispatch.offDuty.asc ? 1 : 0
    }
    VueApp.$store.commit('dispatch/setOffDutyLoading', true)
    VueApp.$store.commit('dispatch/setDriversTotal', {
      field: 'offDuty',
      value: 0
    })
    VueApp.$sdk.get('/provider', request, r => {
      VueApp.$store.commit('dispatch/setOffDutyLoading', false)
      if (r.error) {
        console.log(r)
        return
      }

      let result = []
      for (let i = 0; i < r.list.length; i++) {
        result.push(self.formatData(r.list[i], false, VueApp))
      }

      VueApp.$store.commit('dispatch/setOffDutyDrivers', result)
      VueApp.$store.commit('dispatch/setOffDutyTotalPages', r.paging.totalItems)
      VueApp.$store.commit('dispatch/setDriversTotal', {
        field: 'offDuty',
        value: r.paging.totalItems
      })
    })
  },

  getStagingDrivers (VueApp) {
    let filterIndex = VueApp.$store.state.reservation.selectedFilter
    if (filterIndex < 0 || filterIndex === 'custom') {
      VueApp.$store.commit('dispatch/resetStagingDriver')
      return
    }

    let filter = VueApp.$store.state.reservation.reservationFilters[filterIndex]
    let filterStagingLotIds = filter.stagingLotIds

    if (!Array.isArray(filterStagingLotIds)) {
      VueApp.$store.commit('dispatch/resetStagingDriver')
      return
    }

    let stagingLotIds = []
    for (let i = 0; i < filterStagingLotIds.length; i++) {
      let id = filterStagingLotIds[i]
      if (id === '') {
        continue
      }

      stagingLotIds.push(parseInt(id))
    }

    if (stagingLotIds.length === 0) {
      VueApp.$store.commit('dispatch/resetStagingDriver')
      return
    }

    let self = this
    let request = {
      token: VueApp.$store.state.session.sessionToken,
      stagingLotGeofenceId: stagingLotIds,
      duty: 1,
      pageNum: VueApp.$store.state.dispatch.staging.pageNum,
      pageSize: VueApp.$store.state.dispatch.staging.pageSize,
      order: VueApp.$store.state.dispatch.staging.order,
      orderAsc: VueApp.$store.state.dispatch.staging.asc ? 1 : 0
    }

    VueApp.$store.commit('dispatch/setStagingLoading', true)
    VueApp.$store.commit('dispatch/setDriversTotal', {
      field: 'staging',
      value: 0
    })
    VueApp.$sdk.get('/provider', request, r => {
      VueApp.$store.commit('dispatch/setStagingLoading', false)
      if (r.error) {
        // TODO: process error
        VueApp.$store.commit('dispatch/resetStagingDriver')
        console.log(r)
        return
      }
      VueApp.$store.commit('dispatch/setDriversTotal', {
        field: 'staging',
        value: r.paging.totalItems
      })

      let result = []
      for (let i = 0; i < r.list.length; i++) {
        result.push(self.formatData(r.list[i], false, VueApp))
      }

      if (result.length <= 0) {
        VueApp.$store.commit('dispatch/resetStagingDriver')
        return
      }

      VueApp.$store.commit('dispatch/setStagingDrivers', result)
      if (r.paging) {
        VueApp.$store.commit('dispatch/setStagingTotalPages', r.paging.totalItems)
      }
    })
  },

  updateDriverLists (VueApp, driverId, onDuty) {
    let self = this
    self.getDriver(VueApp, driverId, r => {
      if (r.error) {
        return
      }

      let driver = self.formatData(r, true, VueApp)
      VueApp.$store.commit('dispatch/removeFromOnDutyDrivers', driver.id)
      VueApp.$store.commit('dispatch/removeFromOffDutyDrivers', driver.id)
      if (onDuty) {
        VueApp.$store.commit('dispatch/addToOnDutyDrivers', driver)
      } else {
        VueApp.$store.commit('dispatch/addToOffDutyDrivers', driver)
      }
      self.getStagingDrivers(VueApp)
    })
  },

  updateDriverStatus (VueApp, driverId) {
    let self = this
    self.getDriver(VueApp, driverId, r => {
      if (r.error) {
        return
      }

      let driver = self.formatData(r, false, VueApp)
      VueApp.$store.commit('dispatch/removeFromOnDutyDrivers', driver.id)
      VueApp.$store.commit('dispatch/removeFromOffDutyDrivers', driver.id)
      if (r.duty) {
        VueApp.$store.commit('dispatch/addToOnDutyDrivers', driver)
      } else {
        VueApp.$store.commit('dispatch/addToOffDutyDrivers', driver)
      }
      self.getStagingDrivers(VueApp)
    })
  },

  getDriver (VueApp, driverId, callback) {
    VueApp.$sdk.get('/provider/' + driverId, {
      token: VueApp.$store.state.session.sessionToken
    }, callback)
  },

  getNearbyDrivers (VueApp, request, callback) {
    let processResponse = r => {}

    if (callback) {
      processResponse = callback
    }

    VueApp.$sdk.post('/provider', request, processResponse)
  },

  getLocation (VueApp, driverID, callback) {
    VueApp.$sdk.get('/provider/' + driverID + '/tracks', {
      token: VueApp.$store.state.session.sessionToken
    }, callback)
  },

  getDriverInfo (VueApp, driverID, callback) {
    let self = this
    VueApp.$sdk.get('/provider/' + driverID, {
      token: VueApp.$store.state.session.sessionToken
    }, r => {
      if (r.error) {
        callback(r)
        return
      }

      callback(self.formatData(r, false, VueApp))
    })
  },

  formatData (item, isNew, VueApp) {
    let serviceTypes = []

    if (Array.isArray(item.services)) {
      for (let i = 0; i < item.services.length; i++) {
        serviceTypes.push({
          label: services.getServiceName(item.services[i]),
          class: item.services[i].toLowerCase()
        })
      }
    } else {
      for (let property in item.services) {
        if (!item.services.hasOwnProperty(property) || property === 'undefined') {
          continue
        }
        serviceTypes.push({
          label: services.getServiceName(property),
          class: property.toLowerCase()
        })
      }
    }

    let onBoard = 0
    let status = 'Available'
    if (item.rsvp !== null) {
      onBoard = item.rsvp.passengers
      status = 'Ongoing'
    }

    if (item.stagingLot !== null && item.rsvp === null) {
      status = 'On Staging'
    }

    let stagingLot = null

    if (item.stagingLot) {
      stagingLot = {}
      stagingLot.id = item.stagingLot.geofenceId
      stagingLot.name = item.stagingLot.geofenceName
      stagingLot.services = []

      let stagingServices = item.stagingLot.services
      for (let i = 0; i < stagingServices.length; i++) {
        let stagingService = stagingServices[i]
        let serviceName = ''
        if (!stagingService.serviceType) {
          let serviceList = VueApp.$store.state.services.list
          let index = serviceList.findIndex(x => x.id === stagingService.serviceTypeId)
          if (index > -1) {
            serviceName = serviceList[index].label
          }
        } else {
          serviceName = stagingService.serviceType === 'suv' ? 'SUV' :
          stagingService.serviceType.toLowerCase().replace(/(^| )(\w)/g, s => s.toUpperCase())
        }
        // let serviceName = stagingService.serviceType === 'suv' ? 'SUV' :
        // stagingService.serviceType.toLowerCase().replace(/(^| )(\w)/g, s => s.toUpperCase())
        let serviceStatus = stagingService.status === 'ondeck' ? 'OnDeck' :
                            stagingService.status.toLowerCase().replace(/(^| )(\w)/g, s => s.toUpperCase())

        stagingLot.services.push({
          serviceTypeId: stagingService.serviceTypeId,
          serviceName: serviceName,
          serviceClass: stagingService.serviceType,
          status: serviceStatus,
          priority: stagingService.priority
        })
      }
    }

    let driverData = {
      id: item.ID,
      driverNum: item.driverNum ? `${item.providerAccountType.toUpperCase()}-${item.driverNum}` : item.ID,
      firstName: item.firstName,
      lastName: item.lastName,
      phone: item.phone,
      email: item.email,
      photoUrl: item.avatarUrl,
      licenseType: item.providerAccountType,
      serviceTypes: serviceTypes,
      businessName: item.businessName,
      capacity: item.vehicle.seatCapacity,
      onBoard: onBoard,
      status: status,
      isNew: isNew,
      coords: {
        lat: null,
        lng: null
      },
      vehicle: {
        name: item.vehicle.manufacturer + ' ' + item.vehicle.model,
        licensePlate: item.vehicle.licensePlate,
        photoUrl: item.vehicle.photoUrl ? item.vehicle.photoUrl : item.vehicle.photo
      },
      rsvp: item.rsvp,
      stagingLot: stagingLot,
      hasExpiringDoc: item.hasExpiringDoc,
      countryCode: item.countryCode,
      nationalNumber: item.nationalNumber
    }
    // if (!CONFIG.useOldQuatation) {
    //   driverData.serviceTypes
    // }

    return driverData
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/dispatch/drivers.js